import { getLiveChatMessages } from '../common/api/getLiveChatMessages';

class MessagePollingService {
  intervalId: NodeJS.Timeout;
  messageId: string;

  start(messageId: string, interval: number) {
    if (this.intervalId) {
      return;
    }
    this.messageId = messageId;
    this.intervalId = setInterval(() => {
      getLiveChatMessages(this.messageId);
    }, interval);
  }

  updateLastMessage(messageId: string) {
    this.messageId = messageId;
  }

  stop() {
    try {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    } catch (e) {}
  }
}

export const messagesPolling = new MessagePollingService();
